export default {
    ab: 'abkhaze',
    ace: 'aceh',
    ach: 'acoli',
    ada: 'adangme',
    ady: 'adygh\u00e9en',
    aa: 'afar',
    afh: 'afrihili',
    af: 'afrikaans',
    agq: 'aghem',
    ain: 'a\u00efnou',
    ak: 'akan',
    akk: 'akkadien',
    bss: 'akoose',
    akz: 'Alabama',
    sq: 'albanais',
    gsw: 'al\u00e9manique',
    ale: 'al\u00e9oute',
    arq: 'Algerian Arabic',
    de: 'allemand',
    de_AT: 'allemand autrichien',
    de_CH: 'allemand suisse',
    alt: 'alta\u00ef du Sud',
    zgh: 'amazighe standard marocain',
    ase: 'American Sign Language',
    am: 'amharique',
    ang: 'ancien anglais',
    fro: 'ancien fran\u00e7ais',
    goh: 'ancien haut allemand',
    sga: 'ancien irlandais',
    anp: 'angika',
    en: 'anglais',
    en_US: 'anglais am\u00e9ricain',
    en_AU: 'anglais australien',
    en_GB: 'anglais britannique',
    en_CA: 'anglais canadien',
    njo: 'Ao Naga',
    ar: 'arabe',
    ar_001: 'arabe standard moderne',
    shu: 'arabe tchadien',
    an: 'aragonais',
    arc: 'aram\u00e9en',
    sam: 'aram\u00e9en samaritain',
    aro: 'Araona',
    arp: 'arapaho',
    arn: 'araukan',
    arw: 'arawak',
    hy: 'arm\u00e9nien',
    as: 'assamais',
    asa: 'assou',
    ast: 'asturien',
    cch: 'atsam',
    av: 'avar',
    ae: 'avestique',
    awa: 'awadhi',
    ay: 'aymara',
    az: 'az\u00e9ri',
    ba: 'bachkir',
    bfq: 'Badaga',
    ksf: 'bafia',
    bfd: 'bafut',
    bqi: 'Bakhtiari',
    ban: 'balinais',
    bal: 'baloutchi',
    bm: 'bambara',
    bax: 'bamoun',
    bjn: 'Banjar',
    nds: 'bas-allemand',
    dsb: 'bas-sorabe',
    eu: 'basque',
    bas: 'bassa',
    bbc: 'Batak Toba',
    bar: 'Bavarian',
    bej: 'bedja',
    bem: 'bemba',
    bez: 'b\u00e9na',
    bn: 'bengali',
    bew: 'Betawi',
    bho: 'bhojpuri',
    bi: 'bichelamar',
    be: 'bi\u00e9lorusse',
    bik: 'bikol',
    bin: 'bini',
    my: 'birman',
    bpy: 'Bishnupriya',
    byn: 'blin',
    brx: 'bodo',
    bs: 'bosniaque',
    bum: 'boulou',
    bua: 'bouriate',
    brh: 'Brahui',
    bra: 'braj',
    br: 'breton',
    bug: 'bugi',
    bg: 'bulgare',
    cad: 'caddo',
    frc: 'Cajun French',
    yue: 'cantonais',
    cps: 'Capiznon',
    kea: 'capverdien',
    krl: 'car\u00e9lien',
    car: 'caribe',
    ca: 'catalan',
    cay: 'cayuga',
    ceb: 'cebuano',
    dtp: 'Central Dusun',
    esu: 'Central Yupik',
    ksb: 'chambala',
    ch: 'chamorro',
    chr: 'cherokee',
    chy: 'cheyenne',
    chb: 'chibcha',
    qug: 'Chimborazo Highland Quichua',
    zh: 'chinois',
    zh_Hans: 'chinois simplifi\u00e9',
    zh_Hant: 'chinois traditionnel',
    chp: 'chipewyan',
    shi: 'chleuh',
    cho: 'choctaw',
    chk: 'chuuk',
    si: 'cinghalais',
    swb: 'comorien',
    cop: 'copte',
    ko: 'cor\u00e9en',
    kw: 'cornique',
    co: 'corse',
    cr: 'cree',
    mus: 'creek',
    mfe: 'cr\u00e9ole mauricien',
    hr: 'croate',
    dak: 'dakota',
    da: 'danois',
    dar: 'dargwa',
    dzg: 'dazaga',
    del: 'delaware',
    din: 'dinka',
    dyo: 'diola-fogny',
    dyu: 'dioula',
    doi: 'dogri',
    dgr: 'dogrib',
    dua: 'douala',
    dz: 'dzongkha',
    sco: '\u00e9cossais',
    efi: 'efik',
    arz: 'Egyptian Arabic',
    egy: '\u00e9gyptien ancien',
    eka: 'ekajuk',
    elx: '\u00e9lamite',
    ebu: 'embou',
    egl: 'Emilian',
    myv: 'erzya',
    es: 'espagnol',
    es_ES: 'espagnol d\u2019Europe',
    es_419: 'espagnol latino-am\u00e9ricain',
    es_MX: 'espagnol mexicain',
    eo: 'esp\u00e9ranto',
    et: 'estonien',
    ee: '\u00e9w\u00e9',
    ewo: '\u00e9wondo',
    ext: 'Extremaduran',
    fan: 'fang',
    fat: 'fanti',
    fo: 'f\u00e9ro\u00efen',
    fj: 'fidjien',
    hif: 'Fiji Hindi',
    fil: 'filipino',
    fi: 'finnois',
    nl_BE: 'flamand',
    fon: 'fon',
    gur: 'Frafra',
    fr: 'fran\u00e7ais',
    fr_CA: 'fran\u00e7ais canadien',
    fr_CH: 'fran\u00e7ais suisse',
    ksh: 'francique ripuaire',
    frp: 'franco-proven\u00e7al',
    fur: 'frioulan',
    frr: 'frison du Nord',
    fy: 'frison occidental',
    frs: 'frison oriental',
    gaa: 'ga',
    gd: 'ga\u00e9lique \u00e9cossais',
    gag: 'gagaouze',
    gl: 'galicien',
    cy: 'gallois',
    gan: 'Gan Chinese',
    lg: 'ganda',
    gay: 'gayo',
    gba: 'gbaya',
    ka: 'g\u00e9orgien',
    aln: 'Gheg Albanian',
    bbj: 'ghomala',
    glk: 'Gilaki',
    gil: 'gilbertais',
    gom: 'Goan Konkani',
    gon: 'gondi',
    gor: 'gorontalo',
    got: 'gotique',
    grb: 'grebo',
    el: 'grec',
    grc: 'grec ancien',
    kl: 'groenlandais',
    gn: 'guarani',
    gez: 'gu\u00e8ze',
    gu: 'gujarati',
    guz: 'gusii',
    gwi: 'gwich\u02bcin',
    hai: 'haida',
    ht: 'ha\u00eftien',
    hak: 'Hakka Chinese',
    ha: 'haoussa',
    hsb: 'haut-sorabe',
    haw: 'hawa\u00efen',
    he: 'h\u00e9breu',
    hz: 'h\u00e9r\u00e9ro',
    hil: 'hiligaynon',
    hi: 'hindi',
    ho: 'hiri motu',
    hit: 'hittite',
    hmn: 'hmong',
    hu: 'hongrois',
    hup: 'hupa',
    sah: 'iakoute',
    iba: 'iban',
    ibb: 'ibibio',
    io: 'ido',
    ig: 'igbo',
    ilo: 'ilokano',
    id: 'indon\u00e9sien',
    inh: 'ingouche',
    izh: 'Ingrian',
    ia: 'interlingua',
    ie: 'interlingue',
    iu: 'inuktitut',
    ik: 'inupiaq',
    ga: 'irlandais',
    is: 'islandais',
    it: 'italien',
    jam: 'Jamaican Creole English',
    ja: 'japonais',
    chn: 'jargon chinook',
    jv: 'javanais',
    kaj: 'jju',
    jrb: 'jud\u00e9o-arabe',
    jpr: 'jud\u00e9o-persan',
    jut: 'Jutish',
    quc: 'k\u2019iche\u2019',
    kbd: 'kabardin',
    kab: 'kabyle',
    kac: 'kachin',
    csb: 'kachoube',
    kgp: 'Kaingang',
    kkj: 'kako',
    kln: 'kalenjin',
    xal: 'kalmouk',
    kam: 'kamba',
    kbl: 'kanembou',
    kn: 'kannada',
    kr: 'kanouri',
    kaa: 'karakalpak',
    krc: 'karatcha\u00ef balkar',
    ks: 'kashmiri',
    kaw: 'kawi',
    kk: 'kazakh',
    ken: 'Kenyang',
    kha: 'khasi',
    km: 'khmer',
    kho: 'khotanais',
    khw: 'Khowar',
    cgg: 'kiga',
    ki: 'kikuyu',
    kmb: 'kiMboundou',
    krj: 'Kinaray-a',
    ky: 'kirghize',
    kiu: 'Kirmanjki',
    tlh: 'klingon',
    bkm: 'kom',
    kv: 'komi',
    koi: 'komi-permiak',
    kg: 'kongo',
    kok: 'konkani',
    kfo: 'koro',
    avk: 'Kotava',
    kum: 'koumyk',
    khq: 'koyra chiini',
    ses: 'koyraboro senni',
    kpe: 'kpell\u00e9',
    kri: 'Krio',
    kj: 'kuanyama',
    ku: 'kurde',
    kru: 'kurukh',
    kos: 'kusaien',
    kut: 'kutenai',
    nmg: 'kwasio',
    lad: 'ladino',
    lah: 'lahnda',
    lkt: 'lakota',
    lam: 'lamba',
    lag: 'langi',
    und: 'langue ind\u00e9termin\u00e9e',
    lo: 'lao',
    ltg: 'Latgalian',
    la: 'latin',
    lzz: 'Laz',
    lv: 'letton',
    lez: 'lezghien',
    lij: 'Ligurian',
    li: 'limbourgeois',
    ln: 'lingala',
    lfn: 'Lingua Franca Nova',
    lzh: 'Literary Chinese',
    lt: 'lituanien',
    liv: 'Livonian',
    jbo: 'lojban',
    lmo: 'Lombard',
    sli: 'Lower Silesian',
    loz: 'lozi',
    lu: 'luba-katanga',
    lua: 'luba-lulua',
    lui: 'luiseno',
    lun: 'lunda',
    luo: 'luo',
    lus: 'lushai',
    lb: 'luxembourgeois',
    mde: 'maba',
    mk: 'mac\u00e9donien',
    jmc: 'machame',
    mad: 'madurais',
    maf: 'mafa',
    mag: 'magahi',
    vmf: 'Main-Franconian',
    mai: 'maithili',
    mak: 'makassar',
    mgh: 'makhuwa-meetto',
    kde: 'makonde',
    ms: 'malais',
    ml: 'malayalam',
    dv: 'maldivien',
    mg: 'malgache',
    mt: 'maltais',
    mdr: 'mandar',
    mnc: 'mandchou',
    man: 'mandingue',
    mni: 'manipuri',
    gv: 'manx',
    mi: 'maori',
    mr: 'marathe',
    chm: 'mari',
    mh: 'marshall',
    mwr: 'marwar\u00ee',
    mas: 'masai',
    mzn: 'Mazanderani',
    byv: 'medumba',
    men: 'mend\u00e9',
    mwv: 'Mentawai',
    mer: 'merou',
    mgo: 'm\u00e9ta\u2019',
    mic: 'micmac',
    nan: 'Min Nan Chinese',
    min: 'minangkabau',
    xmf: 'Mingrelian',
    mwl: 'mirandais',
    moh: 'mohawk',
    mdf: 'moksa',
    ro_MD: 'moldave',
    lol: 'mongo',
    mn: 'mongol',
    mos: 'mor\u00e9',
    ary: 'Moroccan Arabic',
    enm: 'moyen anglais',
    frm: 'moyen fran\u00e7ais',
    gmh: 'moyen haut-allemand',
    mga: 'moyen irlandais',
    dum: 'moyen n\u00e9erlandais',
    mul: 'multilingue',
    mua: 'mundang',
    ttt: 'Muslim Tat',
    mye: 'my\u00e8n\u00e8',
    nqo: 'n\u2019ko',
    naq: 'nama',
    nap: 'napolitain',
    na: 'nauruan',
    nv: 'navaho',
    nd: 'nd\u00e9b\u00e9l\u00e9 du Nord',
    nr: 'nd\u00e9b\u00e9l\u00e9 du Sud',
    ng: 'ndonga',
    nl: 'n\u00e9erlandais',
    ne: 'n\u00e9palais',
    new: 'newari',
    nwc: 'newar\u00ee classique',
    sba: 'ngambay',
    nnh: 'ngiemboon',
    jgo: 'ngomba',
    yrl: 'Nheengatu',
    nia: 'nias',
    niu: 'niu\u00e9',
    nog: 'noga\u00ef',
    no: 'norv\u00e9gien',
    nb: 'norv\u00e9gien bokm\u00e5l',
    nn: 'norv\u00e9gien nynorsk',
    nov: 'Novial',
    nus: 'nuer',
    nym: 'nyamwezi',
    ny: 'nyanja',
    nyn: 'nyankol\u00e9',
    nyo: 'nyoro',
    nzi: 'nzema',
    oc: 'occitan',
    oj: 'ojibwa',
    luy: 'oluluyia',
    or: 'oriya',
    om: 'oromo',
    osa: 'osage',
    os: 'oss\u00e8te',
    udm: 'oudmourte',
    uga: 'ougaritique',
    ug: 'ou\u00efghour',
    ur: 'ourdou',
    uz: 'ouzbek',
    ps: 'pachto',
    pal: 'pahlavi',
    pfl: 'Palatine German',
    pau: 'palau',
    pi: 'pali',
    pam: 'pampangan',
    pag: 'pangasinan',
    pap: 'papiamento',
    pa: 'pendjabi',
    pdc: 'Pennsylvania German',
    fa: 'persan',
    peo: 'persan ancien',
    ff: 'peul',
    phn: 'ph\u00e9nicien',
    pcd: 'Picard',
    pms: 'Piedmontese',
    pdt: 'Plautdietsch',
    pon: 'pohnpei',
    pl: 'polonais',
    pnt: 'Pontic',
    pt: 'portugais',
    pt_BR: 'portugais br\u00e9silien',
    pt_PT: 'portugais d\u2019Europe',
    pro: 'proven\u00e7al ancien',
    prg: 'Prussian',
    qu: 'quechua',
    root: 'racine',
    raj: 'rajasthani',
    rap: 'rapanui',
    rar: 'rarotongien',
    rif: 'Riffian',
    rgn: 'Romagnol',
    rm: 'romanche',
    rof: 'rombo',
    rtm: 'Rotuman',
    ro: 'roumain',
    rn: 'roundi',
    rug: 'Roviana',
    ru: 'russe',
    rue: 'Rusyn',
    rwk: 'rwa',
    rw: 'rwanda',
    ssy: 'saho',
    saq: 'samburu',
    smn: 'sami d\u2019Inari',
    smj: 'sami de Lule',
    se: 'sami du Nord',
    sma: 'sami du Sud',
    sms: 'sami skolt',
    sm: 'samoan',
    sgs: 'Samogitian',
    sad: 'sandawe',
    sg: 'sangho',
    sbp: 'sangu',
    zxx: 'sans contenu linguistique',
    sa: 'sanskrit',
    sat: 'santal',
    sc: 'sarde',
    sas: 'sasak',
    sdc: 'Sassarese Sardinian',
    stq: 'Saterland Frisian',
    saz: 'Saurashtra',
    sly: 'Selayar',
    sel: 'selkoupe',
    seh: 'sena',
    see: 'seneca',
    sr: 'serbe',
    sh: 'serbo-croate',
    srr: 's\u00e9r\u00e8re',
    sei: 'Seri',
    st: 'sesotho',
    shn: 'shan',
    sn: 'shona',
    scn: 'sicilien',
    sid: 'sidamo',
    bla: 'siksika',
    szl: 'Silesian',
    sd: 'sindhi',
    den: 'slavey',
    cu: 'slavon d\u2019\u00e9glise',
    sk: 'slovaque',
    sl: 'slov\u00e8ne',
    xog: 'soga',
    sog: 'sogdien',
    so: 'somali',
    snk: 'sonink\u00e9',
    ckb: 'sorani',
    nso: 'sotho du Nord',
    su: 'soundanais',
    sus: 'soussou',
    azb: 'South Azerbaijani',
    srn: 'sranan tongo',
    sv: 'su\u00e9dois',
    suk: 'sukuma',
    sux: 'sum\u00e9rien',
    sw: 'swahili',
    swc: 'swahili du Congo',
    ss: 'swati',
    zbl: 'symboles Bliss',
    syr: 'syriaque',
    syc: 'syriaque classique',
    tg: 'tadjik',
    tl: 'tagalog',
    ty: 'tahitien',
    dav: 'taita',
    tly: 'Talysh',
    tmh: 'tamacheq',
    tzm: 'tamazight',
    ta: 'tamoul',
    trv: 'taroko',
    twq: 'tasawaq',
    tt: 'tatar',
    chg: 'tchaghata\u00ef',
    cs: 'tch\u00e8que',
    ce: 'tch\u00e9tch\u00e8ne',
    cv: 'tchouvache',
    te: 't\u00e9lougou',
    tem: 'temne',
    ter: 'tereno',
    teo: 'teso',
    tet: 'tetum',
    th: 'tha\u00ef',
    bo: 'tib\u00e9tain',
    tig: 'tigr\u00e9',
    ti: 'tigrigna',
    tiv: 'tiv',
    tli: 'tlingit',
    tpi: 'tok pisin',
    tkl: 'tokelau',
    tog: 'tonga nyasa',
    to: 'tonguien',
    fit: 'Tornedalen Finnish',
    tyv: 'touva',
    tkr: 'Tsakhur',
    tsd: 'Tsakonian',
    tsi: 'tsimshian',
    ts: 'tsonga',
    tn: 'tswana',
    tcy: 'Tulu',
    tum: 'tumbuka',
    aeb: 'Tunisian Arabic',
    tr: 'turc',
    crh: 'turc de Crim\u00e9e',
    ota: 'turc ottoman',
    tk: 'turkm\u00e8ne',
    tru: 'Turoyo',
    tvl: 'tuvalu',
    tw: 'twi',
    kcg: 'tyap',
    rom: 'tzigane',
    uk: 'ukrainien',
    umb: 'umbundu',
    vai: 'va\u00ef',
    rup: 'valaque',
    ve: 'venda',
    vec: 'Venetian',
    vep: 'Veps',
    vi: 'vietnamien',
    non: 'vieux norrois',
    vo: 'volapuk',
    vro: 'V\u00f5ro',
    vot: 'vote',
    vun: 'vunjo',
    wal: 'walamo',
    wa: 'wallon',
    wae: 'walser',
    war: 'waray',
    was: 'washo',
    guc: 'Wayuu',
    vls: 'West Flemish',
    mrj: 'Western Mari',
    wo: 'wolof',
    wuu: 'Wu Chinese',
    xh: 'xhosa',
    hsn: 'Xiang Chinese',
    yav: 'yangben',
    yao: 'yao',
    yap: 'yapois',
    ybb: 'yemba',
    ii: 'yi du Sichuan',
    yi: 'yiddish',
    yo: 'yoruba',
    zap: 'zapot\u00e8que',
    dje: 'zarma',
    zza: 'zazaki',
    zea: 'Zeelandic',
    zen: 'zenaga',
    za: 'zhuang',
    gbz: 'Zoroastrian Dari',
    zu: 'zoulou',
    zun: 'zuni'
};
